class HighlightGrid extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        centered: true,
        slides: {
          perView: 2.5,
          spacing: 18,
          origin: 'auto',
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 2.5,
              spacing: 18,
              origin: 'auto',
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.md +
            1}px)`]: {
            disabled: true,
          },
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      ],
    )
  }
}

if (!customElements.get('highlight-grid')) {
  customElements.define('highlight-grid', HighlightGrid)
}
